import { useEffect, useState } from 'react';
import styles from './Avatar.module.scss';

interface Props {
  firstName: string;
  lastName: string;
}

const colors = ['#ff6319', '#012a73', '#00afd8'];

const Avatar = ({ firstName, lastName }: Props): JSX.Element => {
  const [avatarColour, setAvatarColour] = useState('');
  useEffect(() => setAvatarColour(colors[Math.floor(Math.random() * 3)]), []);
  return (
    <div className={styles.avatar} style={{ backgroundColor: avatarColour }}>
      {firstName?.charAt(0)}
      {lastName?.charAt(0)}
    </div>
  );
};

export default Avatar;
